export default __webpack_public_path__ + "static/media/decline_press_start.f5d17385.svg";